import posthog from 'posthog-js'

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig()

  const posthogClient = posthog.init(runtimeConfig.public.POSTHOG_KEY, {
    api_host: runtimeConfig.public.POSTHOG_HOST
  })

  // Solo configurar el router si posthog se inicializó correctamente
  if (posthogClient) {
    const router = useRouter()
    router.afterEach((to, from) => {
      nextTick(() => {
        if (from.fullPath !== to.fullPath) {
          posthog.capture('$pageleave', {
            current_url: from.fullPath,
          })
        }
  
        posthog.capture('$pageview', {
          current_url: to.fullPath
        })
      })
    })
  }

  return {
    provide: {
      posthog: () => posthogClient
    }
  }
})